import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    statsLoading: false,
    coupons: [],
    stats: {
      total_issued: 0,
      total_used: 0,
      outstanding_liability: 0,
      count_active: 0,
      count_used: 0,
      count_expired: 0
    },
    page: 1,
    page_size: 10,
    total: 0,
    page_count: 0,
    order_column: 'created_at',
    order_type: 'desc',
    statusFilter: '',
    campaignFilter: '',
    emailFilter: '',
    searchFilter: '',
    dialog: false
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setStatsLoading(state, payload) {
      state.statsLoading = payload
    },
    setCoupons(state, payload) {
      state.coupons = payload
    },
    setStats(state, payload) {
      state.stats = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setTotal(state, payload) {
      state.total = payload
    },
    setPageCount(state, payload) {
      state.page_count = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setStatusFilter(state, payload) {
      state.statusFilter = payload
    },
    setCampaignFilter(state, payload) {
      state.campaignFilter = payload
    },
    setEmailFilter(state, payload) {
      state.emailFilter = payload
    },
    setSearchFilter(state, payload) {
      state.searchFilter = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    reset(state) {
      state.coupons = []
      state.page = 1
      state.page_size = 10
      state.total = 0
      state.page_count = 0
      state.order_column = 'created_at'
      state.order_type = 'desc'
      state.loading = false
      state.statusFilter = ''
      state.campaignFilter = ''
      state.emailFilter = ''
      state.searchFilter = ''
    }
  },

  actions: {
    /**
     * Read stats
     * @param {Object} commit - The commit function
     * @returns {Promise<void>}
     */
    async readStats({ commit }) {
      try {
        commit('setStatsLoading', true)

        const r = await axios.admin.get('web3/quest-coupons/stats')

        if (r.data.success && r.data.stats) commit('setStats', r.data.stats)
      } finally {
        commit('setStatsLoading', false)
      }
    },

    /**
     * Read coupons
     * @param {Object} commit - The commit function
     * @param {Object} state - The state object
     * @returns {Promise<void>}
     */
    async read({ commit, state }) {
      commit('setLoading', true)

      const params = {
        page: state.page,
        perPage: state.page_size,
        orderBy: `${state.order_column},${state.order_type}`
      }

      if (state.statusFilter) {
        params.status = state.statusFilter
      }
      if (state.campaignFilter) {
        params.campaign_name = state.campaignFilter
      }
      if (state.emailFilter) {
        params.recipient_email = state.emailFilter
      }
      if (state.searchFilter) {
        params.search = state.searchFilter
      }

      try {
        const r = await axios.admin.get('web3/quest-coupons', { params })
        if (r.data.success && r.data.coupons) {
          commit('setCoupons', r.data.coupons.data)
          commit('setTotal', r.data.coupons.total)
          commit('setPageCount', r.data.coupons.last_page)
        }
      } finally {
        commit('setLoading', false)
      }
    },

    /**
     * Create a coupon
     * @param {Object} commit - The commit function
     * @param {Object} dispatch - The dispatch function
     * @param {Object} payload - The payload containing the coupon data
     * @returns {Promise<void>}
     */
    async create({ commit, dispatch }, payload) {
      const r = await axios.admin.post('web3/quest-coupons', payload)
      
      if (r.data.success) {
        commit('setDialog', false)
        dispatch('read')
        dispatch('readStats')
      }
    },

    /**
     * Delete a coupon
     * @param {Object} dispatch - The dispatch function
     * @param {number} id - The ID of the coupon to delete
     * @returns {Promise<void>}
     */
    async delete({ dispatch }, id) {
      const r = await axios.admin.delete(`web3/quest-coupons/${id}`)

      if (r.data.success) {
        dispatch('read')
        dispatch('readStats')
      }
    }
  },

  getters: {
    getCoupons(state) {
      return state.coupons
    },
    getStats(state) {
      return state.stats
    }
  }
}
